import { TOKEN, USER_ID } from 'constants/localStorage';

const POPUP_SESSION = 'mspp.callscribe.popupSession';

export interface IPopupAuth {
  accessToken: string;
  userId: string;
}

let held: IPopupAuth | null = null;

const parse = (raw: string | null): IPopupAuth | null => {
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as Partial<IPopupAuth> | null;
    return typeof value?.accessToken === 'string' &&
      value.accessToken !== '' &&
      typeof value.userId === 'string' &&
      value.userId !== ''
      ? { accessToken: value.accessToken, userId: value.userId }
      : null;
  } catch {
    return null;
  }
};

const stored = (): IPopupAuth | null => {
  try {
    return parse(window.sessionStorage.getItem(POPUP_SESSION));
  } catch {
    return null;
  }
};

export const heldPopupSession = (): IPopupAuth | null => {
  held ??= stored();
  return held;
};

export const holdPopupSession = ({ accessToken, userId }: IPopupAuth): void => {
  held = { accessToken, userId };
  try {
    window.sessionStorage.setItem(POPUP_SESSION, JSON.stringify(held));
  } catch {
    return undefined;
  }
};

export const dropPopupSession = (): void => {
  held = null;
  try {
    window.sessionStorage.removeItem(POPUP_SESSION);
  } catch {
    return undefined;
  }
};

export const adoptSharedSession = (): void => {
  if (heldPopupSession()) return;
  const accessToken = localStorage.getItem(TOKEN);
  const userId = localStorage.getItem(USER_ID);
  if (accessToken && userId) holdPopupSession({ accessToken, userId });
};
